import { apiClient } from '@/shared/api/client'

export async function getAssignedLeads(params = {}) {
  const response = await apiClient.get('/sales/leads', {
    params,
  })

  return response.data
}

export async function getLeadById(leadId) {
  const response = await apiClient.get(`/sales/leads/${leadId}`)

  return response.data
}

export async function updateLead(leadId, payload) {
  const response = await apiClient.put(`/sales/leads/${leadId}`, payload)

  return response.data
}

export async function updateLeadStatus(leadId, status) {
  const response = await apiClient.patch(`/sales/leads/${leadId}/status`, {
    status,
  })

  return response.data
}

export async function confirmLeadFollowUp(leadId) {
  const response = await apiClient.patch(
    `/sales/leads/${leadId}/follow-up/confirm`,
  )

  return response.data
}

export async function sendLeadEmail(leadId, payload) {
  const response = await apiClient.post(`/sales/leads/${leadId}/email`, payload)

  return response.data
}

export async function createLead(payload) {
  const response = await apiClient.post('/sales/leads', payload)

  return response.data
}

export async function bulkUploadLeads(file) {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post('/sales/leads/bulk-upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}
